module.exports = __webpack_public_path__ + "img/financiar-thumb-back-exotics.60175991.png";